import { Injectable, inject } from '@angular/core';
import { IEventoSirena, IListado, IQueryParam } from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from '../../auxiliares/servicios/helper.service';
import { HttpApiAdminService } from '../../auxiliares/servicios/http-api.service';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class EventosSirenasService {
  private http = inject(HttpApiAdminService);
  private helper = inject(HelperService);

  public listar(
    queryParams?: IQueryParam,
  ): Observable<IListado<IEventoSirena>> {
    let params = this.helper.getQueryParams(queryParams);
    return this.http.get(`/eventosSirenas`, { params });
  }

  public listarPorId(id: string): Observable<IEventoSirena> {
    return this.http.get(`/eventosSirenas/${id}`);
  }

  public exportar(queryParams?: IQueryParam): Promise<void> {
    return new Promise((resolve, reject) => {
      let params = this.helper.getQueryParams(queryParams);

      this.http
        .get(`/eventosSirenas/exportar`, { params, responseType: 'blob' })
        .subscribe(
          (response: any) => {
            try {
              const file = new File([response], 'eventos.xlsx');
              saveAs(file);
              resolve();
            } catch (error) {
              console.error(error);
              resolve();
            }
          },
          (error: any) => {
            console.error(error);
            resolve();
          },
        );
    });
  }
}
